var lib_core      = require("lib-core");
var lib_geometry  = require("lib-geometry");

//var OrbitControls = require("./orbitControls.js"); // impliment trackball controlls extension

var THREE                    = require("three");

var Editor3dModel = function (config) {
    lib_core.Model.call(this);

    this.config = config;

    this.state = this.value("state", true);
    this.state("idle");
    this.type  = this.value("type", true);

    // interaction models
    this.interactionModelDataMap = this.map("interactionModels", true);

    this.selectionHandles = this.set("selectionHandles", false);

    // canvas dimension and absolute position
    this.canvasRect = this.value("canvasRect", true);
    this.canvasRect(new lib_geometry.BoundingBox(0, 0, 0, 0));

    this.mousePos = this.value("mousePos", true);
    this.mousePos(new lib_geometry.Coord(0,0));
    this.mouseDisplacement = this.value("mouseDisplacement", true);
    this.mouseDisplacement(new lib_geometry.Coord(0,0));
};

lib_core.inherit(Editor3dModel, lib_core.Model);
Editor3dModel.$class = "Editor3dModel";

module.exports = Editor3dModel;


Editor3dModel.prototype.getRelativeMouseCoord = function (event) {
    return new lib_geometry.Coord(event.pageX-this.canvasRect().x, event.pageY-this.canvasRect().y);
};


Editor3dModel.prototype.registerHandle = function(handleModel){
    this.selectionHandles.add(handleModel);
};

Editor3dModel.prototype.redrawAll = function(){

    // TODO
    // use spacial index to get collisions, then just pass in the list
    // of data that needs to be redrawn.  get IMs from data map and do below
    // for just those

    this.interactionModelDataMap.forEach(function(me, other){
        if(other.collisionRedraw){
            other.collisionRedraw(true);
        }
    });
}







